<script lang="ts">
	import Blok from '$lib/storyblok/blok.svelte';
	import EmailModal from '$lib/storyblok/parts/emailModal.svelte';
	import type { ISbStoryData } from '@storyblok/js';

	interface Props {
		content: ISbStoryData<{
			body: Array<ISbStoryData>;
			open_delay: string;
			ignored_url_params?: string;
		}>['content'];
	}

	let { content }: Props = $props();

	let modal = $state<{ show: () => void; hide: () => void; remove: () => void }>();
</script>

<EmailModal
	bind:modal
	size="fullscreen"
	eventName="Show Quiz Modal"
	openDelay={parseInt(content.open_delay, 10)}
	ignoredParams={content.ignored_url_params?.split(',')}
	modalParam="quiz"
>
	{#each content.body as block}
		<Blok content={block} onclose={() => modal?.hide()} />
	{/each}
</EmailModal>
